/**
 * The brand this build is for. `VITE_BRAND` is inlined by Vite at build time,
 * so every check below is a constant in the shipped bundle.
 *
 *   VITE_BRAND unset      → Utopian Creations agency site (unchanged)
 *   VITE_BRAND=hollerpost → Hollerpost product app (app.hollerpost.com)
 */
import { BRANDS, brandForSlug } from './brands';

export { BRANDS };

export const BRAND = brandForSlug(import.meta.env.VITE_BRAND);

// Compared against the raw env string (not BRAND.mode) so Rollup can fold it
// to a literal and drop product-only branches from the agency bundle.
export const IS_PRODUCT = import.meta.env.VITE_BRAND === 'hollerpost';

// CSS custom properties for brand-themed surfaces. Applied inline on the
// product-mode wrappers (auth pages, portal header) rather than globally, so
// the rest of the dashboard keeps its existing look.
export const brandCssVars = {
  '--brand-primary': BRAND.colors.primary,
  '--brand-primary-hover': BRAND.colors.primaryHover,
  '--brand-on-primary': BRAND.colors.onPrimary,
  '--brand-accent-text': BRAND.colors.accentText,
  '--brand-ink': BRAND.colors.ink,
  '--brand-surface': BRAND.colors.surface,
  '--brand-success': BRAND.colors.success,
  ...(IS_PRODUCT ? {
    '--brand-band': BRAND.colors.band,
    '--brand-muted': BRAND.colors.muted,
    '--brand-line': BRAND.colors.line,
  } : {}),
};
